import React from 'react';

const NotFound = () => {
  return (
    <div>
      404
      вернуться на главную
      
    </div>
  );
};

export default NotFound;
